module.exports = __webpack_public_path__ + "static/images/styles/images/tooltip/bg-borders.9e4925de.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/tooltip/bg-borders.png
// module id = 3846
// module chunks = 11